// extracted by mini-css-extract-plugin
export default {"NabForMarriege":"NabForMarriege_NabForMarriege__3PFgg"};